<template>
<div>
  <v-row align="center" justify="center">
    <v-col>
      <v-card class="elevation-8 pt-12 pb-12 pl-6 pr-6">
        <v-img height="120" contain src="../../assets/Pelican_LogoB.png"></v-img>
        </br></br>
        <center>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
            <b>
              <font face="微軟正黑體" size="5" color="#5A5AAD">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font></br>
              <font face="微軟正黑體" size="5" color="#5A5AAD">常溫單</font>
            </b>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
            <b>
              <font face="微軟正黑體" size="5" color="#5B5B5B">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font></br>
              <font face="微軟正黑體" size="5" color="#5B5B5B">低溫單</font>
            </b>
          </div>
          <div v-else>
            <b>
              <font face="微軟正黑體" size="5" color="#000000">
                {{ $cookie.get('dsmid_token').substr(0,4) }}-{{ $cookie.get('dsmid_token').substr(4,4) }}-{{ $cookie.get('dsmid_token').substr(8,4) }}-{{ $cookie.get('dsmid_token').substr(12,3) }}
              </font> <br />
              <font face="微軟正黑體" size="5" color="#000000"></font>
            </b>
          </div>
        </center><br />
        <div v-if="agree_type===false">
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
            <v-card color="#5A5AAD" class=" pt-2 pb-2">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#E6E6F2">寄件人資料</font>
                </b>
              </center>
            </v-card>
            <v-card color="#E6E6F2" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人名稱：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field dense outlined maxlength="16" background-color="#fff" style="height:30px; width:300px;" v-model="start_name" :rules="start_name_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人連絡電話</font>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">手機：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="10" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_phone" :rules="start_phone_R" placeholder="例:0912345678"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">市話：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_telphone" :rules="start_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人通訊地址</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <SelectZipcode v-model="start_cityIdx" :options="start_cities" />&emsp;
                  <SelectZipcode v-model="start_areaIdx" :options="start_areas" />&ensp;
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="start_address" :rules="start_address_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
            <v-card color="#5B5B5B" class=" pt-2 pb-2">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#F0F0F0">寄件人資料</font>
                </b>
              </center>
            </v-card>
            <v-card color="#F0F0F0" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人名稱：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field dense outlined maxlength="16" background-color="#fff" style="height:30px; width:300px;" v-model="start_name" :rules="start_name_R"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人連絡電話</font>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">手機：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="10" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_phone" :rules="start_phone_R" placeholder="例:0912345678"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">市話：</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="start_telphone" :rules="start_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人通訊地址</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <SelectZipcode v-model="start_cityIdx" :options="start_cities" />&emsp;
                  <SelectZipcode v-model="start_areaIdx" :options="start_areas" />&ensp;
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="start_address" :rules="start_address_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <v-card color="#CCA700" class=" pt-2 pb-2">
            <center>
              <b>
                <font face="微軟正黑體" size="5" color="#FFFFDF">收件人資料</font>
              </b>
            </center>
          </v-card>
          <v-card color="#FFFFDF" class=" pt-3 pb-6">
            <b>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">收件人名稱：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <v-col>
                  <v-text-field outlined dense maxlength="16" background-color="#fff" style="height: 30px;  width: 300px;" v-model="end_name" :rules="end_name_R"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">收件人連絡電話</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">手機：</font>
                <v-col>
                  <v-text-field outlined dense maxlength="10" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="end_phone" :rules="end_phone_R" placeholder="例:0912345678"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">市話：</font>
                <v-col>
                  <v-text-field outlined dense maxlength="16" background-color="#fff" height="5" style="height: 30px;  width: 200px;" v-model="end_telphone" :rules="end_telphone_R" placeholder="例:02-12345678#分機"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;<font face="微軟正黑體" size="4" color="#CCA700">收件人通訊地址</font>
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <SelectZipcode v-model="end_cityIdx" :options="end_cities" />&emsp;
                <SelectZipcode v-model="end_areaIdx" :options="end_areas" />
              </v-row>
              <v-row class="mb-3" no-gutters>&ensp;
                <v-col>
                  <v-text-field outlined dense maxlength="24" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="end_address" :rules="end_address_R"></v-text-field>
                </v-col>
              </v-row>
            </b>
          </v-card>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
            <v-card color="#5A5AAD" class=" pt-3 pb-3">
              <br />
            </v-card>
            <v-card color="#E6E6F2" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">溫層：</font>
                  &ensp;<input type="radio" id="runoob" value="01" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                  </label>
                  <font face="微軟正黑體" size="4" color="#5A5AAD">常溫</font>
                  <!--&emsp;<input type="radio" id="runoob" value="02" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                </label>
                <font face="微軟正黑體" size="4" color="#5A5AAD">冷凍</font>
                &emsp;<input type="radio" id="runoob" value="03" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                </label>
                <font face="微軟正黑體" size="4" color="#5A5AAD">冷藏</font>-->
                </v-row>
                <div v-if="this.goods_type!=='01'">
                  &ensp;<font face="微軟正黑體" size="4" color="#FF5252">
                    {{goods_type_MSG}}<br /><br />
                  </font>
                </div>
                <div v-if="(this.today_Starttype===true)&&(this.today_Endtype===true)">
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">當日宅配：&emsp;&emsp;&emsp;</font>
                    <select v-model="today_type">
                      <option value="F">否</option>
                      <option value="T">是</option>
                    </select>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">當日宅配：&emsp;&emsp;&emsp;</font>
                    <select v-model="today_type" disabled>
                      <option value="F">否</option>
                      <option value="T">是</option>
                    </select>
                  </v-row>
                </div>
                <div v-if="this.today_type==='T'">
                  <v-row class="mb-3" no-gutters>
                    <font face="微軟正黑體" size="4" color="#FF5252">
                      &ensp;僅限台北市、新北市、基隆市三地互寄，當日<br />
                      &ensp;上午11：30前交寄，皆可於當日15~20時送達<br />
                    </font>
                  </v-row>
                </div>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件日：&emsp;&emsp;&emsp;&emsp;</font>
                  <v2-datepicker v-model="entry_date" lang="en" format="YYYY/MM/DD" value="new Date()" disabled></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">希望配達日：&emsp;&emsp;</font>
                  <v2-datepicker v-model="assign_date" lang="en" format="YYYY/MM/DD"></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">希望配達時段：&emsp;</font>
                  <select v-model="assign_no">
                    <option value="00">不指定</option>
                    <option value="01">13時前</option>
                    <option value="02">14-18時</option>
                  </select>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">內容物：&emsp;&emsp;&emsp;&emsp;</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="5" background-color="#fff" height="5" style="height: 30px;  width: 160px;" v-model="product" :rules="product_R" placeholder="須和紙本欄位相同"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">商品價值：&emsp;&emsp;&emsp;</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="6" background-color="#fff" height="5" style="height: 30px;  width: 160px;" v-model="product_value" :rules="product_value_R" placeholder="須和紙本欄位相同"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">備註(上限20字)：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="20" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="reg_memo" :rules="reg_memo_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
            <v-card color="#5B5B5B" class=" pt-3 pb-3">
              <br />
            </v-card>
            <v-card color="#F0F0F0" class=" pt-3 pb-6">
              <b>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">溫層：</font>
                  <!--&emsp;<input type="radio" id="runoob" value="01" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                </label>
                <font face="微軟正黑體" size="4" color="#5B5B5B">常溫</font>-->
                  &emsp;<input type="radio" id="runoob" value="02" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                  </label>
                  <font face="微軟正黑體" size="4" color="#5B5B5B">冷凍</font>
                  &emsp;<input type="radio" id="runoob" value="03" v-model="goods_type" style="height: 30px;  width: 30px;"><label for="runoob">
                  </label>
                  <font face="微軟正黑體" size="4" color="#5B5B5B">冷藏</font>
                </v-row>
                <div v-if="this.goods_type!==''">
                  &ensp;<font face="微軟正黑體" size="4" color="#FF5252">{{goods_type_MSG}}<br /></font>
                  &ensp;<font face="微軟正黑體" size="4" color="#FF5252">{{goods_type_MSG1}}<br /></font><br />
                </div>
                <div v-if="(this.today_Starttype===true)&&(this.today_Endtype===true)">
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">當日宅配：&emsp;&emsp;&emsp;</font>
                    <select v-model="today_type">
                      <option value="F">否</option>
                      <option value="T">是</option>
                    </select>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="mb-3" no-gutters>
                    &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">當日宅配：&emsp;&emsp;&emsp;</font>
                    <select v-model="today_type" disabled>
                      <option value="F">否</option>
                      <option value="T">是</option>
                    </select>
                  </v-row>
                </div>
                <div v-if="this.today_type==='T'">
                  <v-row class="mb-3" no-gutters>
                    <font face="微軟正黑體" size="4" color="#FF5252">
                      &ensp;僅限台北市、新北市、基隆市三地互寄，當日<br />
                      &ensp;上午11：30前交寄，皆可於當日15~20時送達<br />
                    </font>
                  </v-row>
                </div>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件日：&emsp;&emsp;&emsp;&emsp;</font>
                  <v2-datepicker v-model="entry_date" lang="en" format="YYYY/MM/DD" value="new Date()" disabled></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">希望配達日：&emsp;&emsp;</font>
                  <v2-datepicker v-model="assign_date" lang="en" format="YYYY/MM/DD"></v2-datepicker>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">希望配達時段：&emsp;</font>
                  <select v-model="assign_no">
                    <option value="00">不指定</option>
                    <option value="01">13時前</option>
                    <option value="02">14-18時</option>
                  </select>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">內容物：&emsp;&emsp;&emsp;&emsp;</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="5" background-color="#fff" height="5" style="height: 30px;  width: 160px;" v-model="product" :rules="product_R" placeholder="須和紙本欄位相同"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">商品價值：&emsp;&emsp;&emsp;</font>
                  <v-col>
                    <v-text-field outlined dense maxlength="6" background-color="#fff" height="5" style="height: 30px;  width: 160px;" v-model="product_value" :rules="product_value_R" placeholder="須和紙本欄位相同"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-3" no-gutters>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">備註(上限20字)：</font>
                </v-row>
                <v-row class="mb-3" no-gutters>&ensp;
                  <v-col>
                    <v-text-field outlined dense maxlength="20" background-color="#fff" height="5" style="height: 30px;  width: 360px;" v-model="reg_memo" :rules="reg_memo_R"></v-text-field>
                  </v-col>
                </v-row>
              </b>
            </v-card>
          </div>
          </br></br>
          <!--<v-btn color="#F44336" x-large width="150" @click="dialog_ToteNotice = true">
          <font color="#FFF7FB">託運注意事項</font>
        </v-btn>-->
          <div style="text-align:right">
            <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
              <!--<v-btn color="#5A5AAD" x-large @click="dialog_ToteNotice = true">-->
              <v-btn color="#5A5AAD" x-large @click="btnChkData()">
                <!--<font color="#FFF7FB">確定填寫資料</font>-->
                <font color="#FFF7FB">下一步</font>
              </v-btn>
            </div>
            <div v-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
              <!--<v-btn color="#5B5B5B" x-large @click="dialog_ToteNotice = true">-->
              <v-btn color="#5A5AAD" x-large @click="btnChkData()">
                <!--<font color="#FFF7FB">確定填寫資料</font>-->
                <font color="#FFF7FB">下一步</font>
              </v-btn>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
            <v-card color="#5A5AAD" class=" pt-3 pb-3">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#E6E6F2">資料確認</font>
                </b>
              </center>
            </v-card>
            <v-card color="#E6E6F2" class=" pt-3 pb-3">
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_phone }}/{{ start_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zip}}&ensp;{{ this.start_cities[start_cityIdx].name }}{{ this.start_areas[start_areaIdx].name }}{{ start_address }}
                </font>
              </v-row>
              </br>
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">收件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_phone }}/{{ end_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">通訊地址：</font></br>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{end_zip}}&ensp;{{ this.end_cities[end_cityIdx].name }}{{ this.end_areas[end_areaIdx].name }}{{ end_address }}
                </font>
              </v-row>
              </br>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(entry_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">希望配達日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(assign_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">希望配達時段：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ assign_no_name(assign_no) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">溫層：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ goods_type_name(goods_type) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">內容物：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">商品價值：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product_value }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">備註：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ reg_memo }}</font>
              </v-row>
              <center>
                <v-btn color="#5A5AAD" x-large @click="btnBAKData()">
                  <font color="#E6E6F2" face="微軟正黑體" size="4">返回修改</font>
                </v-btn>&ensp;
                <!--<v-btn color="#5A5AAD" x-large @click="btnChkData()">-->
                <v-btn color="#5A5AAD" x-large @click="dialog_userpassword=true">
                  <font color="#E6E6F2" face="微軟正黑體" size="4">確定送出</font>
                </v-btn>
              </center>
            </v-card>
          </div>
          <div v-else-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
            <v-card color="#5B5B5B" class=" pt-3 pb-3">
              <center>
                <b>
                  <font face="微軟正黑體" size="5" color="#F0F0F0">資料確認</font>
                </b>
              </center>
            </v-card>
            <v-card color="#F0F0F0" class=" pt-3 pb-3">
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ start_phone }}/{{ start_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zip}}&ensp;{{ this.start_cities[start_cityIdx].name }}{{ this.start_areas[start_areaIdx].name }}{{ start_address }}
                </font>
              </v-row>
              </br>
              <v-row class="mb-3" no-gutters>
                <b>
                  &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">收件人</font>
                </b>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">名稱：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_name }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">電話：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ end_phone }}/{{ end_telphone }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">通訊地址：</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{end_zip}}&ensp;{{ this.end_cities[end_cityIdx].name }}{{ this.end_areas[end_areaIdx].name }}{{ end_address }}
                </font>
              </v-row>
              </br>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(entry_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">希望配達日期：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ dateFormat(assign_date) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">希望配達時段：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ assign_no_name(assign_no) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">溫層：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ goods_type_name(goods_type) }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">內容物：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">商品價值：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ product_value }}</font>
              </v-row>
              <v-row class="mb-3" no-gutters>
                &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">備註：</font>
                <font face="微軟正黑體" size="4" color="#555555">{{ reg_memo }}</font>
              </v-row>

              <center>
                <v-btn color="#5B5B5B" x-large @click="btnBAKData()">
                  <font color="#F0F0F0" face="微軟正黑體" size="4">返回修改</font>
                </v-btn>&emsp;
                <!--<v-btn color="#5B5B5B" x-large @click="btnChkData()">-->
                <v-btn color="#5B5B5B" x-large @click="dialog_userpassword=true">
                  <font color="#F0F0F0" face="微軟正黑體" size="4">確定送出</font>
                </v-btn>
              </center>
            </v-card>
          </div>
        </div>

        <v-row justify="center">
          <!--Dialog_託運條款-->
          <v-dialog v-model="dialog_Tote" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 primary">
                <font color="#ECF5FF">寄件人 / 店舖人員 登入</font>
              </v-card-title>
              <div v-if="this.login_type===true">
                <v-card-text>
                  <center>
                    </br></br>
                    <v-btn color="primary" x-large width="300" @click="login_type=false;login_sendertype=true">
                      <font size="5">寄件人 登入</font>
                    </v-btn>
                    </br></br>
                    <v-btn color="secondary" x-large width="300" @click="login_type=false;login_storetype=true">
                      <font size="5">店舖人員 登入</font>
                    </v-btn>
                    </br></br></br></br>
                  </center>
                </v-card-text>
              </div>
              <div v-else>
                <v-card-text>
                  </br></br>
                  <div v-if="this.login_sendertype===true">
                    <b>
                      <font face="微軟正黑體" size="5" color="#1976D2">寄件人 登入密碼：</font></br></br>
                    </b>
                    <v-text-field :type="showpswd ? 'text':'password'" class="font-weight-bold" outlined v-model="password" :rules="passwordRules" autocomplete="off" placeholder="寄件人電話(手機/市話)"></v-text-field>
                  </div>
                  <div v-if="this.login_storetype===true">
                    <b>
                      <font face="微軟正黑體" size="5" color="#5B5B5B">店舖人員 登入密碼：</font></br></br>
                    </b>
                    <v-text-field :type="showpswd ? 'text':'password'" class="font-weight-bold" outlined v-model="password" :rules="passwordRules" autocomplete="off" placeholder="代收點分類(英文字母2碼)+店舖編號(數字6碼)"></v-text-field>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" x-large width="100" @click="btnChkPWS()">
                    <font size="4">確 定</font>
                  </v-btn>
                  <v-btn color="warning" x-large width="100" :to="{ name: 'EndPagefail2c' }">
                    <font size="4">離 開</font>
                  </v-btn>
                </v-card-actions></br>
              </div>
            </v-card>
          </v-dialog>
          <!--Dialog_託運注意事項-->
          <!--<v-dialog v-model="dialog_ToteNotice" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 warning">
                <font color="#FFF3EE">託 運 注 意 事 項</font>
              </v-card-title>
              <v-card-text>
                </br>
                1.請勿交寄商品價值超過壹萬元之物品。</br>
                <font color="#FF5252">
                  2.不可交寄物品：現金、有價證券、票券、護照、身分證、標單、珠寶等其他貴重物品或檢體、活體、危險物品、違禁品、具有通信性質之文件、包裝不良品
                  及自寄件日當日起算三日內即容易變質、腐壞、損毀及功能喪失等物品。特殊品溫儲存的物品如：母乳、水餃、餛飩、湯包等包內餡的麵類製品、冰品及蛋
                  高（未裝飾的起司蛋糕除外）等物品。其餘不可交寄物品之種類詳見託運條款及本公司官網。</br>
                  3.交寄離島包裹務必確認不含液體類包裹與航空違禁品（3C、爆裂物、化學藥劑等），否則託運人需擔負罰緩、完全賠償責任與相關法律責任。寄件至離島地
                  區，恕無法指定希望配達日及時段。
                </font></br>
                4.本公司對於託運物之喪失、毀損應負之責任，以貨件之成本價值並參酌本單據所填貨物價值為判斷賠償依據，不包括運送物本體以外之其他附帶利益或所失
                利益，常溫貨物請於收到貨件三日內（含）提出，逾期得不受理相關賠償等請求；低溫貨物配送完成後，本公司之負責消滅。</br>
                5.宅配單如有填寫虛偽不實（包含但不限於內容物或價值），運送人不負任何運送損害配償責任，且所致本公司之損害及責任（包含但不限於寄託人託運之貨
                品致本公司遭行政機關裁處之處分、罰緩），寄件人應負完全賠償責任。</br>
                6.本單據未經代收點或本公司人員簽章者無效。</br>
                7.個資法及各項託運條款，請詳閱託運條款及隱私權政策。</br>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" x-large width="100" @click="btnAgreeType()">
                  <font size="4">同 意</font>
                </v-btn>
                <v-btn color="warning" x-large width="100" :to="{ name: 'EndPagefail2c' }">
                  <font size="4">不同意</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>-->
          <v-dialog v-model="dialog_userpassword" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 warning">
                <font color="#FFF3EE">修 改 / 查 詢 提 示</font>
              </v-card-title>
              <v-card-text>
                </br></br>
                <font face="微軟正黑體" size="5" color="warning">
                  <div v-if="this.start_phone !== ''">
                    密碼為&ensp;{{this.start_phone}}
                  </div>
                  <div v-else>
                    密碼為&ensp;{{this.start_telphone}}
                  </div>
                </font>
                </br></br></br></br>
                <center>
                  <font face="微軟正黑體" size="4" color="#FF1B1B">本畫面於20秒後自動關閉</font>
                </center>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" x-large width="100" @click="btnchkPassword()">
                  <font size="4">確 定</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_agencystore" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 primary">
                <font color="#ECF5FF">資 料 確 認</font>
              </v-card-title>
              <v-card-text>
                </br>
                <div v-if="$cookie.get('dsmid_token').substr(1,2)==='05'">
                  <v-row class="mb-3" no-gutters>
                    <b>
                      &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">寄件人</font>
                    </b>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">名稱：</font>
                    <font face="微軟正黑體" size="4" color="#5A5AAD">{{ start_name }}</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">電話：</font>
                    <font face="微軟正黑體" size="4" color="#5A5AAD">{{ start_phone }}/{{ start_telphone }}</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">地址：</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD"> {{start_zip}}&ensp;{{ this.start_cities[start_cityIdx].name }}{{ this.start_areas[start_areaIdx].name }}{{ start_address }}
                    </font>
                  </v-row>
                  </br>
                  <v-row class="mb-3" no-gutters>
                    <b>
                      &ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">收件人</font>
                    </b>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">名稱：</font>
                    <font face="微軟正黑體" size="4" color="#5A5AAD">{{ end_name }}</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">電話：</font>
                    <font face="微軟正黑體" size="4" color="#5A5AAD">{{ end_phone }}/{{ end_telphone }}</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD">地址：</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5A5AAD"> {{end_zip}}&ensp;{{ this.end_cities[end_cityIdx].name }}{{ this.end_areas[end_areaIdx].name }}{{ end_address }}
                    </font>
                  </v-row>
                  </br>
                </div>
                <div v-if="$cookie.get('dsmid_token').substr(1,2)==='15'">
                  <v-row class="mb-3" no-gutters>
                    <b>
                      &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">寄件人</font>
                    </b>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">名稱：</font>
                    <font face="微軟正黑體" size="4" color="#555555">{{ start_name }}</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">電話：</font>
                    <font face="微軟正黑體" size="4" color="#555555">{{ start_phone }}/{{ start_telphone }}</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">地址：</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{start_zip}}&ensp;{{ this.start_cities[start_cityIdx].name }}{{ this.start_areas[start_areaIdx].name }}{{ start_address }}
                    </font>
                  </v-row>
                  </br>
                  <v-row class="mb-3" no-gutters>
                    <b>
                      &ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">收件人</font>
                    </b>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">名稱：</font>
                    <font face="微軟正黑體" size="4" color="#555555">{{ end_name }}</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">電話：</font>
                    <font face="微軟正黑體" size="4" color="#555555">{{ end_phone }}/{{ end_telphone }}</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#5B5B5B">地址：</font>
                  </v-row>
                  <v-row class="mb-3" no-gutters>
                    &ensp;&ensp;<font face="微軟正黑體" size="4" color="#555555"> {{end_zip}}&ensp;{{ this.end_cities[end_cityIdx].name }}{{ this.end_areas[end_areaIdx].name }}{{ end_address }}
                    </font>
                  </v-row>
                  </br>
                </div>
                </br>
                <center>
                  <font face="微軟正黑體" size="4" color="#FF1B1B">本畫面於20秒後自動關閉</font>
                </center>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" x-large width="100" @click="dialog_agencystore=false">
                  <font size="4">結束離開</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
  <v-overlay :value="overlay">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</div>
</template>

<script>
import SelectZipcode from "../../components/SelectZipcode";
import cities from "../../components/zipcode.json";

export default {
  components: {
    SelectZipcode,
  },
  data() {
    return {
      dialog_Tote: true,
      //dialog_ToteNotice: false,
      dialog_userpassword: false,
      dialog_agencystore: false,
      showpswd: false,
      overlay: false,
      login_type: true,
      login_sendertype: false,
      login_storetype: false,
      password: '',
      passwordRules: [
        (v) => !!v || " ",
      ],
      agree_type: false,
      start_name: '', //寄件人姓名
      start_name_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.start_name = this.start_name.substr(0, this.start_name.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.start_name = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      start_phone: '', //寄件人手機
      start_phone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.start_phone = ''
          }
          return true
        },
      ],
      start_telphone: '', //寄件人市話 RegExp(/^[^0-9-\-#]*$/).test(v)
      start_telphone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9 \-#]*$/).test(v)) {
            this.start_telphone = ''
          }
          return true
        },
      ],
      start_cityIdx: 0, //撈取寄件人縣市用
      start_areaIdx: 0, //撈取寄件人鄉政用
      start_address: '', //寄件人地址
      start_address_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.start_address = this.start_address.substr(0, this.start_address.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.start_address = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      end_name: '', //收件人姓名
      end_name_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.end_name = this.end_name.substr(0, this.end_name.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&<>%]/).test(v)) {
              this.end_name = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      end_phone: '', //收件人手機
      end_phone_R: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9 #]*$/).test(v)) {
            this.end_phone = ''
          }
          return true
        },
      ],
      end_telphone: '', //收件人市話 RegExp(/^[^0-9-\-#]*$/).test(v)
      end_telphone_R: [
        (v) => !!v || "",
        (v) => {
          if (!RegExp(/^[0-9 \-#]*$/).test(v)) {
            this.end_telphone = ''
          }
          return true
        },
      ],
      end_cityIdx: 0, //撈取收件人縣市用
      end_areaIdx: 0, //撈取收件人鄉政用
      end_address: '', //收件人地址
      end_address_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v.substr(-1, 1))) {
            this.end_address = this.end_address.substr(0, this.end_address.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&]/).test(v)) {
              this.end_address = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
      goods_type: '', //溫層
      goods_type_MSG: '',
      goods_type_MSG1: '',
      today_type: 'F',
      today_Starttype: false,
      today_Endtype: false,
      entry_date: new Date(), //寄件日
      assign_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000), //希望配答日
      assign_no: '00', //希望配達時段
      product: '', //商品名
      product_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>%]/).test(v)) {
            this.product = '';
            alert('資料中有不合規則字元');
          }
          return true
        },
      ],
      product_value: '', //商品價值
      product_value_R: [
        (v) => !!v || " ",
        //(v) => v < 10000 || " ",
        (v) => {
          if (v > 10000) {
            alert('商品金額上限為10,000元');
            this.product_value = ''
          }
          return true
        },
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.product_value = ''
          }
          return true
        },
      ],
      reg_memo: '', //備註
      reg_memo_R: [
        (v) => {
          if (RegExp(/[\\/'"=&<>]/).test(v.substr(-1, 1))) {
            this.reg_memo = this.reg_memo.substr(0, this.reg_memo.length - 1);
            alert('請勿使用不合規則字元');
            return false
          } else {
            if (RegExp(/[\\/'"=&]/).test(v)) {
              this.reg_memo = '';
              alert('資料中有不合規則字元');
              return false
            }
            return true
          }
        },
      ],
    };
  },
  mounted: function() {
    this.checkPage();
    this.goods_type_check();
  },
  computed: {
    start_cities() {
      if ((this.start_cityIdx === '1') || (this.start_cityIdx === '2') || (this.start_cityIdx === '3') ||
        (this.start_cityIdx === 1) || (this.start_cityIdx === 2) || (this.start_cityIdx === 3)) {
        this.today_Starttype = true;
      } else {
        this.today_Starttype = false;
        this.today_type = 'F';
      };
      return cities;
    },
    start_areas() {
      return cities[this.start_cityIdx].areas;
    },
    start_zip() {
      console.log("start_zip：" + this.start_areas[this.start_areaIdx].zip);
      return this.start_areas[this.start_areaIdx].zip;
    },
    end_cities() {
      if ((this.end_cityIdx === '1') || (this.end_cityIdx === '2') || (this.end_cityIdx === '3') ||
        (this.end_cityIdx === 1) || (this.end_cityIdx === 2) || (this.end_cityIdx === 3)) {
        this.today_Endtype = true;
      } else {
        this.today_Endtype = false;
        this.today_type = 'F';
      };
      return cities;
    },
    end_areas() {
      return cities[this.end_cityIdx].areas;
    },
    end_zip() {
      console.log("end_zip：" + this.end_areas[this.end_areaIdx].zip);
      return this.end_areas[this.end_areaIdx].zip;
    },
  },
  watch: {
    /*start_cityIdx() {
      this.start_areaIdx = 0;
      if ((this.start_cityIdx === '1') || (this.start_cityIdx === '2') || (this.start_cityIdx === '3') ||
        (this.start_cityIdx === 1) || (this.start_cityIdx === 2) || (this.start_cityIdx === 3)) {
        this.today_Starttype = true;
      } else {
        this.today_Starttype = false;
        this.today_type = 'F';
      }
    },
    end_cityIdx() {
      this.end_areaIdx = 0;
      if ((this.end_cityIdx === '1') || (this.end_cityIdx === '2') || (this.end_cityIdx === '3') ||
        (this.end_cityIdx === 1) || (this.end_cityIdx === 2) || (this.end_cityIdx === 3)) {
        this.today_Endtype = true;
      } else {
        this.today_Endtype = false;
        this.today_type = 'F';
      }
    },*/
    goods_type() {
      if (this.goods_type === '02') {
        this.goods_type_MSG = "交寄冷凍貨件前請務必預冷12小時以上，";
        this.goods_type_MSG1 = "成凍結狀態";
      } else if (this.goods_type === '03') {
        this.goods_type_MSG = "交寄冷藏貨件前請務必預冷6小時以上";
        this.goods_type_MSG1 = "";
      } else {
        this.goods_type_MSG = "";
        this.goods_type_MSG1 = "";
      }
    },
    dialog_userpassword(val) {
      if (!val) return
      setTimeout(() => (
        this.btnchkPassword()
      ), 20000)
    },
    dialog_agencystore(val) {
      if (!val) return
      setTimeout(() => (
        this.dialog_agencystore = false
      ), 20000)
    },
  },
  methods: {
    checkPage: function() {
      if (this.$cookie.get('page_token') != 'S') {
        this.$router.push({
          name: "ErrorPage"
        });
      } else {
        let page_token = 'E';
        this.$cookie.set('page_token', page_token, "0");
      }
    },
    goods_type_check() {
      if (this.$cookie.get('dsmid_token').substr(1, 2) === '05') {
        this.goods_type = '01';
      } else {
        this.goods_type = '';
      }
    },
    dateFormat(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

      return year.toString() + month.toString() + day.toString();
    },
    assign_no_name(assign_no) {
      if (assign_no === '00') {
        return '不指定';
      } else if (assign_no === '01') {
        return '13時前';
      } else if (assign_no === '02') {
        return '14-18時';
      } else {
        return '';
      }
    },
    goods_type_name(goods_type) {
      if (goods_type === '01') {
        return '常溫';
      } else if (goods_type === '02') {
        return '冷凍';
      } else if (goods_type === '03') {
        return '冷藏';
      } else {
        return '';
      }
    },
    btnChkPWS() {
      //因delphi限制 ( 無法使用 # )，所以將 # 取代為 @
      //let url = 'https://queryapi.e-can.com.tw:9097/EDIQR2Capi/EDIQR2C_Chkdsmid/pass=' + this.password.replace('#', '@') + '&main_id=' + this.$cookie.get('dsmid_token');
      let url = 'https://queryapi2.e-can.com.tw:9091/EDIQR2Capi/EDIQR2C_Chkdsmid/pass=' + this.password.replace('#', '@') + '&main_id=' + this.$cookie.get('dsmid_token');
      this.$axios.get(url).then(response => {
        if (response.data.dsm === '1') {
          this.dialog_Tote = false;
          this.GetDSMData();
        } else if (response.data.dsm === '2') {
          alert('此單以使用');
          this.$router.push({
            name: "ErrorPage"
          });
        } else if (response.data.dsm === '3') {
          alert('密碼錯誤');
          this.dialog_Tote = true;
        } else if (response.data.dsm === '4') {
          this.GetDSMData();
          this.dialog_agencystore = true;
        } else if (response.data.dsm === '5') {
          alert('查無配對資料');
          this.dialog_Tote = true;
        } else {
          this.$router.push({
            name: "ErrorPage"
          });
        }
      }).catch(function(error) {
        this.$router.push({
          name: "ErrorPage"
        });
      })

    },
    GetDSMData() {
      //let urldata = 'https://queryapi.e-can.com.tw:9097/EDIQR2CAPI/EDIQR2C_Data/' + this.$cookie.get('dsmid_token');
      let urldata = 'https://queryapi2.e-can.com.tw:9091/EDIQR2CAPI/EDIQR2C_Data/' + this.$cookie.get('dsmid_token');

      this.$axios.get(urldata).then(response => {
        this.dsmfilelst = response.data;
        console.log(this.dsmfilelst);
        this.inquiry_char = this.dsmfilelst.data[0].inquiry_char;
        this.start_name = this.dsmfilelst.data[0].start_name;
        this.start_cityIdx = this.dsmfilelst.data[0].start_cityno;
        this.start_areaIdx = this.dsmfilelst.data[0].start_areano;
        this.start_zipcode = this.dsmfilelst.data[0].start_zpcode;
        this.start_address = this.dsmfilelst.data[0].start_addr;
        this.start_phone = this.dsmfilelst.data[0].start_phone;
        this.start_telphone = this.dsmfilelst.data[0].start_telphone;
        this.end_name = this.dsmfilelst.data[0].end_name;
        this.end_cityIdx = this.dsmfilelst.data[0].end_cityno;
        this.end_areaIdx = this.dsmfilelst.data[0].end_areano;
        this.end_zipcode = this.dsmfilelst.data[0].end_zpcode;
        this.end_address = this.dsmfilelst.data[0].end_addr;
        this.end_phone = this.dsmfilelst.data[0].end_phone;
        this.end_telphone = this.dsmfilelst.data[0].end_telphone;
        this.goods_type = this.dsmfilelst.data[0].goods_type;
        if (this.dsmfilelst.data[0].assign_date === '') {
          this.assign_date = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        } else {
          this.assign_date = new Date((this.dsmfilelst.data[0].assign_date).substr(0, 4) + '-' + (this.dsmfilelst.data[0].assign_date).substr(4, 2) + '-' + (this.dsmfilelst.data[0].assign_date).substr(6, 2));
        }
        this.assign_no = this.dsmfilelst.data[0].assign_no;
        this.reg_memo = this.dsmfilelst.data[0].memo;
        this.product = this.dsmfilelst.data[0].product;
        this.product_value = this.dsmfilelst.data[0].product_value;

        if ((this.start_cityIdx === '1') || (this.start_cityIdx === '2') || (this.start_cityIdx === '3')) {
          this.today_Starttype = true;
          this.today_type = 'T';
        } else {
          this.today_Starttype = false;
          this.today_type = 'F';
        }
        if ((this.end_cityIdx === '1') || (this.end_cityIdx === '2') || (this.end_cityIdx === '3')) {
          this.today_Endtype = true;
          this.today_type = 'T';
        } else {
          this.today_Endtype = false;
          this.today_type = 'F';
        }

      }).catch(function(error) {
        this.$router.push({
          name: "ErrorPage"
        });
      })
    },
    btnBAKData() {
      this.agree_type = false;
    },
    btnAgreeType() {
      if ((this.start_name !== '') &&
        ((this.start_phone !== '') || (this.start_telphone !== '')) &&
        (this.start_zip !== '') &&
        (this.start_address !== '') &&
        (this.end_name !== '') &&
        ((this.end_phone !== '') || (this.end_telphone !== '')) &&
        (this.end_zip !== '') &&
        (this.end_address !== '') &&
        (this.goods_type !== '') &&
        (this.product_value !== '')
      ) {
        if (this.product_value > 10000) {
          alert('提醒您!!商品理賠上限為10,000元!!');
        }
        //this.dialog_ToteNotice = false;
        this.agree_type = true;
      } else {
        //this.dialog_ToteNotice = false;
        if ((this.start_name === '') ||
          ((this.start_phone === '') && (this.start_telphone === '')) ||
          (this.start_zip === '') ||
          (this.start_address === '')
        ) {
          alert('寄件人資料不完整');
        }
        if ((this.end_name === '') ||
          ((this.end_phone === '') && (this.end_telphone === '')) ||
          (this.end_zip === '') ||
          (this.end_address === '')
        ) {
          alert('收件人資料不完整');
        }
        if (this.goods_type === '') {
          alert('請選擇溫層');
        }
        if (this.product_value === '') {
          alert('請輸入商品價值');
        }
      }
    },
    btnChkData() {
      this.overlay = true;
      let posturl = 'https://queryapi.e-can.com.tw:9097/EDIQR2CAPI/EDIQR2C_UpdData';
      let axiosConfig = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      if (this.start_cityIdx === 0) {
        this.start_cityname = '';
      } else {
        this.start_cityname = this.start_cities[this.start_cityIdx].name;
      }
      if ((this.start_areaIdx === 0) && (this.start_cityIdx === 0)) {
        this.start_areaname = '';
      } else {
        this.start_areaname = this.start_areas[this.start_areaIdx].name;
      }
      if (this.start_areaname === '請選擇區域別') {
        this.start_areaname = '';
      }
      let postdata = JSON.stringify({
        "utype": "upd",
        "main_id": this.$cookie.get('dsmid_token').substr(0, 12),
        "seq_id": this.$cookie.get('dsmid_token').substr(12, 3),
        "spec_id": "01",
        "total_obj": "1",
        "customer_delivery_date": "",
        "agencystore_no": "",
        "delivery_sheet_date": "",
        "company_no": "",
        "inquiry_char": "",
        "start_name": this.start_name,
        "start_phone": this.start_phone,
        "start_telphone": this.start_telphone,
        "start_zpcode": this.start_zip,
        "start_cityno": this.start_cityIdx,
        "start_cityname": this.start_cityname,
        "start_areano": this.start_areaIdx,
        "start_areaname": this.start_areaname,
        "start_addr": this.start_address,
        "end_name": this.end_name,
        "end_phone": this.end_phone,
        "end_telphone": this.end_telphone,
        "end_zpcode": this.end_zip,
        "end_cityno": this.end_cityIdx,
        "end_cityname": this.end_cities[this.end_cityIdx].name,
        "end_areano": this.end_areaIdx,
        "end_areaname": this.end_areas[this.end_areaIdx].name,
        "end_addr": this.end_address,
        "assign_date": this.dateFormat(this.assign_date),
        "assign_no": this.assign_no,
        "original_carriage": "",
        "agency_receipt": "0",
        "goods_type": this.goods_type,
        "input_type": "6",
        "src_type": "1",
        "pay_type": "1",
        "delivery_record": "0",
        "operator_id": "999999",
        "memo": this.reg_memo,
        "start_email": "",
        "crg_memo": "",
        "print_code": "0",
        "seq_no": "1",
        "cust_seq_id": "01",
        "transfer_code": "0",
        "outspec_code": "0",
        "pickup_price": "0",
        "receive_target": "2",
        "payment_target": "1",
        "product": this.product,
        "product_value": this.product_value,
        "effective_code": "1"
      });

      /*let options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: postdata,
        url: posturl,
      };*/
      this.$axios.post(posturl, postdata, axiosConfig).then((response) => {
          if (response.data.pcode === '0') {
            this.overlay = false;
            alert('上傳失敗：' + response.data.desc);
            this.$router.push({
              name: "ErrorPage"
            });
          } else {
            //console.log('上傳成功');
            this.overlay = false;
            if (this.agree_type === true) {
              this.dialog_userpassword = true;
              console.log('[確定資料]上傳成功');
            } else {
              this.btnAgreeType();
              console.log('[KEY資料]上傳成功');
            }
            /*this.$router.push({
              name: "EndPage2c"
            });*/
          }
        })
        .catch((error) => console.log(error));
    },
    btnchkPassword() {
      this.dialog_userpassword = false;
      this.$router.push({
        name: "EndPage2c"
      });
    },
  },
}
</script>
